import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { onCurrentUserInfo, onUserState } from "../../redux/userSlice";
import { googleSignIn, auth } from "../../firebase/firebase";
import FirebaseModule from "../../firebase/FirebaseModule";
import { useNavigate } from "react-router";
import { FN } from "../../miscellaneous/emuns/emuns";
import Icons from "../../miscellaneous/icons/Icons";
import ProgressBar from "../../miscellaneous/progress/ProgressBar";
import { notify } from "../../miscellaneous/reatToastify/ToastNotification";
import logo from "../../miscellaneous/logos/techthrivetransparent.webp";
import stylel from "./Login.module.scss";

/**************************
 * Login
 *************************/
export default function Login() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const firebaseModule = FirebaseModule();
  const [runsOnce, setRunsOnce] = useState<boolean>(false);
  const [progress, setProgress] = useState<boolean>(false);
  const [title, setTitle] = useState({
    denied: "access denied",
    granted: "log in",
    state: false, // true means that access is denied
  });

  const onchange = useCallback(() => {
    setProgress(true);
    auth.onAuthStateChanged(async (user) => {
      if (!user) return;
      let userInfo = {
        id: user.uid,
        email: user.email,
        name: user.displayName,
        permissionlevel: "0",
        photo: user.photoURL,
        totalmontly: "",
        totalannually: "",
        latepayments: "",
        currentservices: "",
        
      };
      try {
        const fetched = await firebaseModule.checkDataInFirebase(
          FN.users,
          user.uid,
        );

        if (!fetched?.exists()) {
          await firebaseModule.addDataInFirebase(FN.users, user.uid, userInfo);
          dispatch(onCurrentUserInfo([userInfo]));
          dispatch(onUserState(true));
          navigate("/dashboard");
        } else if(fetched.exists()) {
          const fetchedData = await firebaseModule.getDocInFirebase(FN.users, "id", user.uid);
          const d = fetchedData.docs.map((items:any) => items.data())
          dispatch(onCurrentUserInfo(d));
          dispatch(onUserState(true));
          navigate("/dashboard");
        }
      } catch (error: any) {
        dispatch(onCurrentUserInfo([]));
        dispatch(onUserState(false));
        console.log(error);
        setTitle({ ...title, state: true });
        setProgress(false);
      }
    });
  }, [dispatch, firebaseModule, navigate, title]);

  useEffect(() => {
    if (runsOnce) {
      onchange();
      setRunsOnce(false);
    }
  }, [runsOnce, onchange]);

  function onSignIn() {
    googleSignIn().then(() => {
      setRunsOnce(true);
    });
  }

  return (
    <>
      <div className={stylel.logincontainer}>
        <div className={stylel.login_wrapper00}>
          {" "}
          <img src={logo} alt="logo-photo" height={"100%"} width={"100%"} />
        </div>
        <div className={stylel.login_wrapper01}>
          <h4>Client Login</h4>

          <button onClick={() => onSignIn()}>
            <Icons iconName="googleIcon" />

            {title.state ? title.denied : title.granted}
          </button>
        </div>
      </div>
      <ProgressBar openModal={progress} />
    </>
  );
}
